// Copyright (c) 2017 Deere & Company

export default Object.freeze({
    DELETE_DEALER_INVOICE_ITEM: 'DELETE_DEALER_INVOICE_ITEM',
    RESET_DEALER_INVOICE_FILTERS: 'RESET_DEALER_INVOICE_FILTERS',
    RESET_DEALER_INVOICE_INVOICE_TO_COMPLETE: 'RESET_DEALER_INVOICE_INVOICE_TO_COMPLETE',
    SELECT_DEALER_INVOICE_DEALER_ACCOUNT_FACET_ITEMS: 'SELECT_DEALER_INVOICE_DEALER_ACCOUNT_FACET_ITEMS',
    SET_DEALER_INVOICE_LIST: 'SET_DEALER_INVOICE_LIST',
    TOGGLE_DEALER_INVOICE_DEALER_ACCOUNT_FACET_ITEMS: 'TOGGLE_DEALER_INVOICE_DEALER_ACCOUNT_FACET_ITEMS',
    UPDATE_DEALER_INVOICE_DEALER_ACCOUNT_FACET_INPUT: 'UPDATE_DEALER_INVOICE_DEALER_ACCOUNT_FACET_INPUT',
    UPDATE_DEALER_INVOICE_DEALER_ACCOUNT_FACET_ITEM: 'UPDATE_DEALER_INVOICE_DEALER_ACCOUNT_FACET_ITEM',
    UPDATE_DEALER_INVOICE_FILTER_BY: 'UPDATE_DEALER_INVOICE_FILTER_BY',
    UPDATE_DEALER_INVOICE_INVOICE_TO_COMPLETE: 'UPDATE_DEALER_INVOICE_INVOICE_TO_COMPLETE',
    UPDATE_DEALER_INVOICE_INVOICE_TO_COMPLETE_CLAIMS_PROCESS: 'UPDATE_DEALER_INVOICE_INVOICE_TO_COMPLETE_CLAIMS_PROCESS',
    UPDATE_DEALER_INVOICE_INVOICE_TO_COMPLETE_MASS_PROCESS: 'UPDATE_DEALER_INVOICE_INVOICE_TO_COMPLETE_MASS_PROCESS',
    UPDATE_DEALER_INVOICE_ITEM: 'UPDATE_DEALER_INVOICE_ITEM',
    UPDATE_DEALER_INVOICE_PROPERTY: 'UPDATE_DEALER_INVOICE_PROPERTY',
    UPDATE_DEALER_INVOICE_SORT_BY: 'UPDATE_DEALER_INVOICE_SORT_BY',
    UPDATE_DEALER_INVOICE_SORT_DIRECTION: 'UPDATE_DEALER_INVOICE_SORT_DIRECTION'
});



// WEBPACK FOOTER //
// ./src/claim/dealer-invoices/actions-list.js